import { useMutation } from "@tanstack/react-query";
import { useAuth, authorizedAxios } from "@moonscape/shared";

export const useSyncTransaction = ({
  onSuccess,
  onError,
}: {
  onSuccess?: () => void;
  onError?: () => void;
}) => {
  const { getToken } = useAuth();

  const mutation = useMutation({
    mutationFn: async (exchangeId: string) => {
      const token = await getToken();
      const res = await authorizedAxios(token).post(`/sync/${exchangeId}`);
      return res.data;
    },
    onSuccess,
    onError,
  });

  return {
    isLoading: mutation.isPending,
    data: mutation.data,
    error: mutation.error,
    sync: mutation.mutate, // Call like sync(exchangeId)
  };
};
